module.exports = __webpack_public_path__ + "img/tree-3.0418e723.png";